<template>
  <div>
    <v-dialog v-model="showConfirmDialog" persistent width="500">
      <v-card>
        <v-row no-gutters>
          <v-col cols="1" class="right-side"></v-col>
          <v-col cols="1">
            <div class="white-space"></div>
            <div class="blue-space"></div>
            <!--<div class="icon-space"></div>-->
            <v-icon class="confirm-icon" color="white">mdi-information mdi-36px</v-icon>
          </v-col>
          <v-col cols="9">
            <v-row no-gutters>
              <v-col cols="12" class="mt-3">
                <span class="title-confirm">{{ title }}</span>
              </v-col>
              <v-col cols="12" class="mt-3">
                <span>{{ text }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-6 mb-4">
              <slot name="action"></slot>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'confirmDialog',
    props: {},
    mounted() {},
    created() {
      this.$root.$refs.confirmDialog = this;
    },
    data() {
      return {
        title: '',
        text: '',
        showConfirmDialog: false,
        pageName: null,
        methodName: null,
        clickType: null,
        getIcon: require('../assets/images/confirm.png'),
      };
    },
    methods: {},
    computed: {},
  };
</script>

<style scoped>
  .hr {
    height: 12vh !important;
    border-top: none;
    border-right: none;
    border-bottom: none;
    border-left: 6px solid darkColor;
  }
  .txt {
    font-size: 15px;
  }
  @media only screen and (max-width: 600px) {
    .txt {
      font-size: 12px;
    }
  }

  .right-side {
    background-color: var(--dark-color) !important;
  }
  .title-confirm {
    font-weight: 600;
    font-size: 14px;
  }
  .text-confirm {
    font-weight: 400;
    font-size: 14px;
  }
  .white-space {
    width: 8vh;
    height: 8vh;
    border-radius: 50% !important;
    background: white;
    margin-top: 5vh;
    margin-right: -3.5vh;
    position: absolute;
  }
  .blue-space {
    width: 6vh;
    height: 6vh;
    background: var(--dark-color);
    border-radius: 50% !important;
    margin-top: 6vh;
    position: absolute;
    margin-right: -2.7vh;
  }
  .icon-space {
    width: 4vh;
    height: 4vh;
    background: white;
    border-radius: 50% !important;
    margin-top: 6.5vh;
    position: absolute;
    margin-right: -2.23vh;
  }
  .confirm-icon {
    margin-top: 6.6vh;
    margin-right: -2.1vh;
  }
</style>
